module.exports = __webpack_public_path__ + "media/images/icons/country_flags/st-b1de9e523e773c7d9318488785ed11a4.svg";